import { render, staticRenderFns } from "./resource-carousel.vue?vue&type=template&id=3e05a7d4&scoped=true"
import script from "./resource-carousel.vue?vue&type=script&lang=js"
export * from "./resource-carousel.vue?vue&type=script&lang=js"
import style0 from "./resource-carousel.vue?vue&type=style&index=0&id=3e05a7d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e05a7d4",
  null
  
)

export default component.exports